import gsap from "gsap";

const animateTakeoff = (rocket, duration = 1, callback = null) => {
    const tl = gsap.timeline();


    tl.to(rocket, { rotation: Math.PI / 36, duration: 0 });
    tl.to(rocket, { rotation: 0, duration: 1, ease: "elastic.out(1.75,0.1)" });
    tl.to(rocket.position, { y: -window.innerHeight, duration: duration, ease: "back.in(0.5)" }, "-=0.5");
    tl.to(rocket.scale, { x: 0.4, y: 0.4, duration: 0, onComplete: callback });

    return tl;
};

const showFeedback = (feedback, duration = 1) => {
    const tl = gsap.timeline();

    gsap.to(feedback, { alpha: 1, duration: duration, ease: "expo.in" });
    tl.to(feedback.scale, { x: 1.1, y: 1.1, duration: duration, ease: "expo.in" });

    tl.to(feedback, { alpha: 0, duration: duration, ease: "expo.in" });
    tl.to(feedback.scale, { x: 1, y: 1, duration: 0 });
};

const animateLanding = (moon, background, rocket, feedback, duration = 1, callback) => {

    const tl = animateTakeoff(rocket, duration, () => { showFeedback(feedback); });

    // LAND STRAIGHT IN THE AXIS OF THE MOON AND DISAPPEAR
    tl.to(rocket.position, { x: moon.position.x, duration: 0 });
    tl.to(rocket, { rotation: 0, duration: 0 });
    tl.to(rocket.position, { y: moon.position.y - moon.width * 0.5, duration: 1, ease: "expo.out" });
    tl.to(rocket, { alpha: 0.0, duration: 0.5, delay: 0.5 });

    // BACK TO INITIAL SETUP
    tl.to(rocket, { width: rocket.width, height: rocket.height, duration: 0 });
    tl.to(rocket, { rotation: 0, duration: 0 });
    tl.to(rocket.position, { x: rocket.position.x, y: rocket.position.y, duration: 0, onComplete: callback });
    tl.to(rocket, { alpha: 1.0, duration: 0.5 });
};

const animateCrash = (background, rocket, feedback, duration = 1, callback) => {

    const tl = animateTakeoff(rocket, duration, () => { showFeedback(feedback); });

    // CRASH, FLICKER AND DISAPPEAR
    const [landX, landY] = [window.innerWidth * Math.random(), background.height * 0.6];
    const distanceToLand = Math.sqrt(Math.pow((landX - rocket.position.x), 2) + Math.pow((landY - (-window.innerHeight)), 2));
    const angleToLand = (landX < window.innerWidth * 0.5 ? 1 : -1) * Math.acos((landY - (-window.innerHeight)) / distanceToLand);
    tl.to(rocket, { rotation: Math.PI + angleToLand, duration: 0 });
    tl.to(rocket.position, { x: landX, y: landY, duration: 1 });
    const angles = [...new Array(5)].map((val, i) => { return (i % 2 == 0) ? Math.PI / 12  : -Math.PI / 12; });
    angles.push(0);
    tl.to(rocket, { keyframes: { rotation: angles.map(angle => angle + (Math.PI + angleToLand)) }, duration: 0.5 }, "-=0.5");
    tl.to(rocket, { alpha: 0.0, duration: 1.2, ease: "expo.in" }, "-=0.2");

    // BACK TO INITIAL SETUP
    tl.to(rocket, { width: rocket.width, height: rocket.height, duration: 0 });
    tl.to(rocket, { rotation: 0, duration: 0 });
    tl.to(rocket.position, { x: rocket.position.x, y: rocket.position.y, duration: 0, onComplete: callback });
    tl.to(rocket, { alpha: 1.0, duration: 0.5 });
};

const animateNoFeedback = (background, rocket, duration = 1, callback) => {

    const tl = animateTakeoff(rocket, duration);

    tl.to(rocket, { alpha: 0.0, duration: 0.5 });

    // BACK TO INITIAL SETUP
    tl.to(rocket, { width: rocket.width, height: rocket.height, duration: 0 });
    tl.to(rocket, { rotation: 0, duration: 0 });
    tl.to(rocket.position, { x: rocket.position.x, y: rocket.position.y, duration: 0, onComplete: callback });
    tl.to(rocket, { alpha: 1.0, duration: 0.5 });

    return tl;
};

const animateTimeout = (background, rocket, timeout, duration = 1, callback) => {
    const tl = gsap.timeline();
    
    gsap.to(timeout, { alpha: 1, duration: duration, ease: "expo.in" });
    tl.to(rocket, { alpha: 0.0, duration: duration });

    tl.to(timeout.scale, { x: 1.1, y: 1.1, duration: duration, ease: "expo.in" });

    tl.to(timeout, { alpha: 0, duration: duration, ease: "expo.in" });
    tl.to(timeout.scale, { x: 1, y: 1, duration: 0, onComplete: callback });

    tl.to(rocket, { alpha: 1.0, duration: duration });
};

export {
    animateLanding,
    animateCrash,
    animateNoFeedback,
    animateTimeout
};